import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIcon12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconIcon12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.904 3.197 2.707 2h6.586L8.096 3.197A3.5 3.5 0 0 0 6 2.5c-.786 0-1.512.26-2.096.697m3.475.717A2.5 2.5 0 0 0 6 3.5c-.51 0-.983.152-1.379.414L6 5.293zM6.707 6l1.379-1.379c.262.396.414.87.414 1.379 0 .51-.152.983-.414 1.379zM5.293 6 3.914 4.621A2.5 2.5 0 0 0 3.5 6c0 .51.152.983.414 1.379zM4.62 8.086 6 6.707l1.379 1.379A2.5 2.5 0 0 1 6 8.5c-.51 0-.983-.152-1.379-.414m-1.424.01A3.5 3.5 0 0 1 2.5 6c0-.786.26-1.512.697-2.096L2 2.707v6.586zM2.707 10l1.197-1.197c.584.438 1.31.697 2.096.697s1.512-.26 2.096-.697L9.293 10zm6.096-6.096L10 2.707v6.586L8.803 8.096C9.241 7.512 9.5 6.786 9.5 6s-.26-1.512-.697-2.096M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIcon12);
